import { type DartySession } from "@/features/partners/session/darty"
import { type PartnerLinks } from "@/features/partners/types/partnerLink"
import { externalRoutesPaths } from "@/routes/external"
import { storyblokRoutesPaths } from "@/routes/storyblok"
import { buildPortailLink } from "../buildPortailLink"

export const DARTY_PORTAIL_LINKS = [
    {
        key: "sales-tracking",
        label: "Suivi des ventes",
        description: "Accéder au suivi des contrats et de la performance.",
        href: "https://dashboard-darty.vercel.app/",
        buildHref: (href, session) => {
            const { accessToken } = session as DartySession

            return buildPortailLink(href, {
                fragment: `oeBackendToken=${accessToken}`,
            })
        },
        target: "_blank",
        img: {
            alt: "Constantine avec un graphique",
            src: "/assets/images/illustrations/chart.svg",
        },
    },
    {
        key: "useful-links",
        label: "Liens utiles",
        description:
            "Retrouvez tous les liens utiles Octopus Energy ainsi que le détails des offres.",
        href: storyblokRoutesPaths.landing.resolve({ pathParams: { landingId: "contact-darty" } }),
        target: "_blank",
        img: {
            alt: "Liens utiles",
            src: "/assets/images/illustrations/statement.svg",
        },
    },
    {
        key: "contact-us",
        label: "Demande urgente",
        description: "Besoin d'aide ? Obtenez une réponse en quelques minutes.",
        href: `${externalRoutesPaths.octopusTypeform.resolve({ pathParams: { formId: "W89F6jyP" } })}?typeform-source=octopusenergy.fr`,
        target: "_blank",
        img: {
            alt: "Constantine au téléphone",
            src: "/assets/images/illustrations/constantine-operator.svg",
        },
    },
] as const satisfies PartnerLinks
